import { render, staticRenderFns } from "./ProviderShowDetails.vue?vue&type=template&id=80c78c96"
import script from "./ProviderShowDetails.vue?vue&type=script&lang=js"
export * from "./ProviderShowDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports